import Image from "next/image"
import styles from "./SingleCategory.module.css"
import { useWindowDimensions } from "../../../hooks/useWindowDimensions"
import ArticleList from "../ArticleList/ArticleList"
import Pagination from "@mui/material/Pagination"
import { useRouter } from "next/router"
import { useRef } from "react"
import React from "react"
import TopicList from "../TopicList/TopicList"
import { Topic } from "../../../interfaces/props.interface"

const ARTICLES_PER_PAGE = 9
const SingleCategory = ({
  topics,
  category,
}: {
  topics: Topic[]
  category: any
}) => {
  const articles = category?.blog
  const { width } = useWindowDimensions()
  const router = useRouter()
  const topicListRef = useRef<HTMLDivElement>(null)
  const currentPage = parseInt(router.query.page as string) || 1
  const totalPages = Math.ceil(articles?.length / ARTICLES_PER_PAGE)
  const currentArticles = articles?.slice(
    (currentPage - 1) * ARTICLES_PER_PAGE,
    currentPage * ARTICLES_PER_PAGE
  )

  const handlePageChange = (event: any, value: number) => {
    const categoryValue = router.query.category
    const newPath = `/categoria/${categoryValue}?page=${value}`
    router.push(newPath, undefined, { shallow: true }).then(() => {
      if (topicListRef.current) {
        window.scrollTo({
          top: topicListRef.current.offsetTop - 100,
          behavior: "smooth",
        })
      }
    })
  }

  return (
    <div className={styles.container}>
      <div className={styles.containerWrap}>
        <Image
          src={
            width <= 850
              ? "/Images/blog-image-phone.svg"
              : "/Images/blog-image.svg"
          }
          alt="Portada blog"
          layout="fill"
          objectFit="cover"
          className={styles.imgRadius}
        />

        <div className={styles.textWrap}>
          <h1 className={styles.title}>{category?.title}</h1>
        </div>
      </div>
      <br />
      <br />
      <div ref={topicListRef}>
        <TopicList topics={topics} selected={category?.slug} />
      </div>
      <br />
      <br />
      <ArticleList articles={currentArticles} />
      <Pagination
        variant="outlined"
        count={totalPages}
        page={currentPage}
        onChange={handlePageChange}
        sx={{
          margin: "4rem 0rem",
          display: "flex",
          justifyContent: "center",
          gap: "2rem",
          "& .MuiPaginationItem-root": {
            color: "var(--fiva-color)", // Este color afecta al texto. Ajusta según necesites.
            backgroundColor: "#DDFFFD", // Color de fondo por defecto para todos los ítems
            width: "50px",
            height: "50px",
            borderRadius: "50px",
            fontSize: "20px",
          },
          "& .Mui-selected": {
            color: "var(--fiva-color)", // Color del texto para el ítem seleccionado. Ajusta según necesites.
            backgroundColor: "#00F5EA", // Color de fondo para el ítem seleccionado
          },
          "& .MuiPaginationItem-root:hover": {
            backgroundColor: "rgba(0, 245, 234, 0.5)", // Color de fondo al pasar el mouse, con una opacidad menor para un efecto suave
          },
          "& .MuiButtonBase-root-MuiPaginationItem-root.Mui-selected": {
            backgroundColor: "#00F5EA",
          },
          "& .MuiPagination-ul": {
            gap: "1rem",
          },
        }}
      />
    </div>
  )
}

export default SingleCategory
